if (!customElements.get("m-scrolling-promotion")) {
  class MScrollingPromotion extends HTMLElement {
    connectedCallback() {
      this.promotion = this.querySelector(".m-promotion");
      this.init();
    }

    init() {
      if (this.childElementCount !== 1) return;

      this.promotion.classList.add("m-promotion--animated");

      for (let index = 0; index < 4; index++) {
        const clone = this.promotion.cloneNode(true);
        clone.setAttribute("aria-hidden", "true");
        clone.querySelectorAll("a, button, input, select, textarea, [tabindex]").forEach((element) => {
          element.setAttribute("tabindex", "-1");
        });
        this.appendChild(clone);
      }

      this.addEventListener("focusin", this.scrollingPause.bind(this));
      this.addEventListener("focusout", this.scrollingPlay.bind(this));
      this.addEventListener("mouseenter", this.scrollingPause.bind(this));
      this.addEventListener("mouseleave", this.scrollingPlay.bind(this));

      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        this.scrollingPause();
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.scrollingPlay();
            } else {
              this.scrollingPause();
            }
          });
        },
        { rootMargin: "0px 0px 50px 0px" }
      );

      observer.observe(this);
    }

    scrollingPlay() {
      this.classList.remove("m-scrolling-promotion--paused");
    }

    scrollingPause() {
      this.classList.add("m-scrolling-promotion--paused");
    }
  }

  customElements.define("m-scrolling-promotion", MScrollingPromotion);
}
